const quick = [
  { label: "本站首页", href: "#home" },
  { label: "官方入口", href: "#entries" },
  { label: "热门看点", href: "#explore" },
  { label: "常用分区", href: "#channels" },
  { label: "使用帮助", href: "#guide" },
  { label: "更新动态", href: "#news" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-secondary-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1">
            <a href="#home" className="inline-flex items-center gap-2.5">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary-500 text-background-50 text-lg font-bold">
                17
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">吃瓜17 导航入口</span>
            </a>
            <p className="mt-4 max-w-sm text-sm text-foreground-600 leading-relaxed">
              吃瓜17导航入口汇总，提供吃瓜17网址地址与最新链接，帮你快速找到主页直达位置。收藏本导航即可一键访问，省去搜索麻烦。
            </p>
          </div>

          <div className="md:col-span-2 flex flex-col sm:flex-row gap-8 sm:justify-end">
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-foreground-400">页面导航</h4>
              <ul className="mt-3 grid grid-cols-2 gap-x-8 gap-y-2.5">
                {quick.map((q) => (
                  <li key={q.label}>
                    <a href={q.href} className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                      {q.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-semibold tracking-widest text-foreground-400">使用建议</h4>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
                主站波动时优先切换备用通道；常用入口建议收藏，更新动态区会及时提示变动，方便长期稳定访问。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜17 导航入口 · 本页为吃瓜17网址地址与链接的收藏整理页
          </p>
          <button
            type="button"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium border border-secondary-300 bg-background-50 text-foreground-700 hover:bg-secondary-100 transition-colors"
          >
            <i className="ri-bookmark-line text-sm" />
            收藏吃瓜17 导航
          </button>
        </div>
      </div>
    </footer>
  );
}